import { DateTime } from "luxon";
import { useMemo } from "react";
import { IanaZone } from "../../../types";
import styles from "./TimezoneMessage.module.scss";

type TimezoneMessageProps = {
  timezone?: IanaZone;
};

export function TimezoneMessage({ timezone }: TimezoneMessageProps) {
  const localTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const showMessage = timezone && timezone !== localTimezone;

  const abbreviation = useMemo(() => {
    if (!timezone) return "";
    return DateTime.now().setZone(timezone).offsetNameShort ?? "";
  }, [timezone]);

  if (!showMessage) return null;

  return (
    <span className={styles["timezone-message"]} data-testid="timezone-message">
      Dates shown in {abbreviation}
    </span>
  );
}
